const translation = {
  routesGroup: {
    home: 'Home',
    iaas: 'IaaS',
    containerService: 'Container Service',
    ai: 'AI',
    others: 'Others',
    systemSetting: 'Site Settings',
  },
  userCenter: 'Profile',
  market: 'Market',
  modelSquare: 'Model Square',
  trialCenter: 'Trial Center',
  // routes title keys
  dashboard: 'Dashboard',
  compute: 'Compute',
  instancesAndImages: 'Instance & Image',
  vm: 'VM instance',
  baremetal: 'Baremetals',
  instanceGroup: 'Server Groups',
  serverTemplate: 'Templates',
  scalingGroup: 'Scaling Groups',
  webApp: 'Webapp',
  systemImage: 'Images',
  hostImage: 'Server Images',
  storageAndBackup: 'Storage & Backup',
  disk: 'Disks',
  diskSnapshot: 'Snapshot',
  instanceSnapshot: 'Server Snapshot',
  snapshotPolicy: 'Snapshot Policies',
  diskBackup: 'Disk Backup',
  instanceBackup: 'Instance Backup',
  networkAndSecurity: 'Network & Security',
  secGroup: 'Security Groups',
  subnet: 'IP Subnet',
  eip: 'EIP',
  tapService: 'Tap Service',
  keypair: 'Keypairs',
  resourceAndSchedule: 'Resource & Schedule',
  sku: 'Configuration',
  host: 'Host',
  physicalMachine: 'Physical Machine',
  gpu: 'Passthrough',
  schedTag: 'Sched Tag',
  schedPolicy: 'Sched Policy',
  dynamicSchedTag: 'Dynamic Sched Tag',
  recycleBin: 'Recycle Bin',
  serverRecovery: 'VM instance',
  diskRecovery: 'Disks',
  imageRecovery: 'Images',
  network: 'Network',
  networkPlan: 'Network Plan',
  region: 'Region',
  zone: 'Zone',
  baseNetwork: 'Base Network',
  vpcInterconnect: 'VPC Interconnect',
  vpcPeer: 'VPC Peer',
  globalVpc: 'Global VPC',
  vpc: 'VPC',
  routeTable: 'Route Table',
  wire: 'Wire',
  networkService: 'Network Service',
  nat: 'NAT Gateway',
  dns: 'DNS',
  ipv6: 'IPv6 Gateway',
  networkSecurity: 'Network Security',
  waf: 'WAF Strategy',
  sshProxy: 'SSH Proxy',
  sshProxyNode: 'Proxy Endpoint',
  sshProxyService: 'Proxy Agent',
  lb: 'Load Balancing',
  lbInstance: 'LB Instances',
  lbAcl: 'Access Control',
  lbCert: 'Certificates',
  lbCluster: 'Load Balancer Cluster',
  lbClusterMain: 'Cluster',
  lbClusterNode: 'Node',
  cdn: 'CDN',
  cdnDomain: 'CDN Domain',
  storage: 'Storage',
  blockStorage: 'Block Storage',
  workload: 'Workload',
  stateless: 'Deployments',
  stateful: 'StatefulSets',
  daemonset: 'DaemonSets',
  job: 'Job',
  cronjob: 'Cron Jobs',
  pod: 'Pods',
  pvc: 'PVC',
  imageRepo: 'Image Repo',
  serviceDiscovery: 'Service Discovery',
  service: 'Service',
  ingress: 'Ingresses',
  configManage: 'Config Manage',
  configmap: 'ConfigMap',
  secret: 'Secrets',
  clusterManage: 'Clusters',
  node: 'Node',
  storageClass: 'Storage Class',
  namespace: 'Namespace',
  role: 'Role',
  clusterRole: 'Cluster Role',
  roleBinding: 'Role Binding',
  clusterRoleBinding: 'Cluster Role Binding',
  serviceAccount: 'Service Account',
  kubeComponent: 'Components',
  federatedCluster: 'Federated Cluster',
  federatedNamespace: 'Namespace',
  federatedRole: 'Role',
  federatedClusterRole: 'Cluster Role',
  federatedRoleBinding: 'Role Binding',
  federatedClusterRoleBinding: 'Cluster Role Binding',
  ml: 'MLOps',
  maasServiceNav: 'Model Service',
  aiMarket: 'AI Market',
  computeMarket: 'Compute Market',
  modelMarket: 'Model Market',
  experienceCenter: 'Experience Center',
  trainAndInference: 'Training & Inference',
  devMachine: 'Dev Machine',
  trainTask: 'Training Task',
  trainTemplate: 'Training Template',
  inferenceService: 'Inference Service',
  aiAssets: 'AI Assets',
  dataset: 'Dataset',
  modelManage: 'Model Management',
  containerImage: 'Container Image',
  repository: 'Repository',
  diskStorage: 'Disk Storage',
  resourceQuota: 'Resource Quota',
  resourceMonitor: 'Resource Monitor',
  resourceAudit: 'Resource Audit',
  modelService: 'Model Service',
  modelMarketGroup: 'Model Market',
  modelServiceGroup: 'Model Service',
  modelServiceSettingGroup: 'System Setting',
  usageStatistics: 'Usage Statistics',
  serviceList: 'Service Price',
  apiKey: 'API Key',
  systemSetting: 'System Setting',
  computeCluster: 'Compute Cluster',
  resourceDashboard: 'Resource dashboard',
  storageCluster: 'Storage Cluster',
  modelServiceSetting: 'Model Service',
  // Keep old translations for backward compatibility
  dataManage: 'Data Manage',
  containerInstance: 'Instance',
  modelList: 'List',
  modelTrain: 'Model Train',
  modelInference: 'Model Deployment',
  serviceSetting: 'Service Setting',
  modelServicePrices: 'Model Service Price',
  apiKeyMgmt: 'API Key Mgmt',
  auditLog: 'Audit Log',
  aiAppBuild: 'AI App Build',
  knowledgeBase: 'Knowledge Base',
  appBuild: 'App Build',
  appMarket: 'App Market',
  monitoringAndOperations: 'Monitoring & Operations',
  overview: 'Overview',
  resource: 'Resource',
  monitorVM: 'Server',
  monitorHost: 'Host',
  monitorMetric: 'Metrics',
  monitorDashboard: 'Dashboard',
  monitorQuery: 'Monitor Query',
  alert: 'Alert',
  alertPolicy: 'Alert Policy',
  alertHistory: 'Alert History',
  alertResource: 'Alert Resource',
  alertPolicy2: 'Alert Policy',
  authenticationAndSecurity: 'IAM & Sec',
  authSystem: 'IAM',
  authIdp: 'Authentication Domain',
  authDomain: 'Domain',
  authProject: 'Project',
  authGroup: 'Group',
  authUser: 'User',
  authRole: 'Role',
  authPolicy: 'Permissions',
  securityAlert: 'Security Alert',
  messageCenter: 'Message Center',
  messageSubscribeSetting: 'Notification Topic',
  notifyChannelSetting: 'Notify Channel Setting',
  contactManage: 'Recipients',
  robotManage: 'Robot Manage',
  systemSetting2: 'System Setting',
  websiteSetting: 'Website Setting',
  licenseSetting: 'License Settings',
}
export default translation
